'use strict'

function isSecureUserArea () {
    return window.location.pathname.startsWith('/secure/user/')
}

/// ////////////////
// Initialization //
/// ////////////////

/**
 * Zentrale Behandlung von 401/403 Fehlern
 * @param {Object} err - Error object from jQuery AJAX
 * @param {boolean} showAlert - Whether to show an alert message
 * @param {string} inlineSelector - Optional: CSS selector for inline alert (e.g., '#profileAlert')
 */
function handleAuthError(err, showAlert = true, inlineSelector = null) {
    if (err.status === 401 || err.status === 403) {
        // Öffentliche Seiten (Login, Rechtstexte): kein Redirect – dort sind keine API-Calls mit Session erwartet
        if (!isSecureUserArea()) {
            return false
        }
        console.warn('🔒 Auth Error (' + err.status + ') - Logging out and redirecting to login...')
        
        // Clear token and user data
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        // Cleanup old token keys (from before migration)
        localStorage.removeItem('api')
        localStorage.removeItem('jwt')
        localStorage.removeItem('jwtToken')
        
        // Optional: Alert anzeigen
        if (showAlert && typeof makeAlertBox === 'function') {
            makeAlertBox(3, 3000, '<i class="fa fa-exclamation-circle"></i> Ihre Sitzung ist abgelaufen. Sie werden zur Anmeldung weitergeleitet...', inlineSelector)
        }
        
        // Zur Login-Seite weiterleiten nach kurzer Verzögerung
        setTimeout(function() {
            window.location.href = '/'
        }, 2000)
        
        return true
    }
    return false
}

/**
 * Dokumententypen-Dropdown aus API 0.10.2 befüllen (UUID-IDs statt Enum).
 * @param {jQuery} $select
 * @param {Array} items
 */
function populateDocumentTypeSelect ($select, items) {
    if (!$select || !$select.length) {
        return
    }
    const previous = $select.val()
    $select.empty()
    $select.append($('<option value="" disabled>Bitte wählen</option>'))
    if (Array.isArray(items)) {
        items.forEach(function (item) {
            const title = (item.attributes && item.attributes.title) ? item.attributes.title : item.id
            $select.append($('<option></option>').attr('value', item.id).text(title))
        })
    }
    if (previous && $select.find('option[value="' + previous + '"]').length) {
        $select.val(previous)
    } else {
        $select.prop('selectedIndex', 0)
    }
}

let documentTypesLoadPromise = null

/**
 * Lädt Dokumententypen einmalig vom Backend-Proxy.
 * @returns {Promise}
 */
function ensureDocumentTypesLoaded () {
    const $select = $('#messageDocumentType')
    if (!$select.length || !localStorage.getItem('token')) {
        return Promise.resolve()
    }
    if ($select.find('option').length > 1) {
        return Promise.resolve()
    }
    if (documentTypesLoadPromise) {
        return documentTypesLoadPromise
    }
    documentTypesLoadPromise = $.ajax({
        url: '/cockpit/document-types',
        method: 'GET',
        global: false
    }).then(function (res) {
        if (res && res.success && res.data && Array.isArray(res.data.data)) {
            populateDocumentTypeSelect($select, res.data.data)
        }
        return res
    }).catch(function (err) {
        documentTypesLoadPromise = null
        if (handleAuthError(err, false)) {
            return
        }
        console.warn('Dokumententypen konnten nicht geladen werden', err)
    })
    return documentTypesLoadPromise
}

$(document).ready(function () {

    initPopups()
    
    // Handle message detail button clicks with event delegation (global - works on all pages)
    $(document).on('click', '.btn-message-detail', function(e) {
        e.preventDefault()
        
        const messageId = $(this).data('message-id')
        const messageType = $(this).data('message-type')
        
        // Open modal first
        const modalElement = document.getElementById('messageDetail')
        if (modalElement) {
            const modal = new bootstrap.Modal(modalElement)
            modal.show()
        } else {
            console.error('Modal element #messageDetail not found')
            return
        }
        
        // Show loading state
        $('#messageDetailContent').html('<div class="text-center p-5"><i class="fa fa-spinner fa-spin fa-3x"></i><p class="mt-3">Nachricht wird geladen...</p></div>')

        // Load message details
        getMessageDetail(messageId)
            .then(function(details) {
                $('#messageDetailContent').html(details)
            })
            .catch(function(err) {
                // Handle auth errors (401/403)
                if (typeof handleAuthError === 'function' && handleAuthError(err, true)) {
                    return // Will redirect to login
                }
                // Show error message for non-auth errors
                const errorMsg = err.responseJSON && err.responseJSON.error ? err.responseJSON.error : 'Fehler beim Laden der Nachricht'
                $('#messageDetailContent').html('<div class="alert alert-danger m-3"><i class="fa fa-exclamation-circle"></i> ' + errorMsg + '</div>')
            })
    })

    // Beim Öffnen des Upload-Modals über Sidebar/Button: parentMessageId zurücksetzen, Reply-Modus deaktivieren
    $(document).on('click', '[data-bs-target="#uploadModal"]', function() {
        if (!$(this).hasClass('btn-reply')) {
            $('#parentMessageId').val('')
            $('#uploadModal').data('replyMode', false)
        }
    })

    // Antworten-Button: Nachrichtendetail schließen, Upload-Modal im reduzierten Modus öffnen
    $(document).on('click', '.btn-reply', function(e) {
        e.preventDefault()
        const messageId = $(this).data('message-id')
        let subject = $(this).data('subject') || ''
        const year = $(this).data('year') || ''
        if (subject && subject.indexOf('AW: ') !== 0 && subject.indexOf('Re: ') !== 0) {
            subject = 'AW: ' + subject
        }
        const messageDetailModal = document.getElementById('messageDetail')
        const uploadModalEl = document.getElementById('uploadModal')
        if (messageDetailModal && bootstrap.Modal.getInstance(messageDetailModal)) {
            bootstrap.Modal.getInstance(messageDetailModal).hide()
        }
        if (uploadModalEl) {
            $('#uploadModal').data('replyMode', true)
            $('#parentMessageId').val(messageId || '')
            $('#messageSubject').val(subject)
            if (year && $('#messageYear').length) {
                $('#messageYear').val(year)
            }
            const uploadModal = new bootstrap.Modal(uploadModalEl)
            uploadModal.show()
        }
    })

    // Upload-Modal: Bei Anzeige Reply-Modus anwenden (nur Nachricht + Anhänge)
    $(document).on('shown.bs.modal', '#uploadModal', function() {
        ensureDocumentTypesLoaded()
        const isReply = $(this).data('replyMode') === true
        const $typeRow = $('#uploadModalTypeRow')
        const $subjectDiv = $('#messageSubjectDiv')
        const $messageType = $('#messageType')
        const $uploadModalLabel = $('#uploadModalLabel')

        const $yearCell = $('#uploadModalYearCell')
        if (isReply) {
            $uploadModalLabel.html('<i class="fa fa-reply me-2"></i>Antwort schreiben')
            $('#messageTypeLabel').text('Antwort als')
            $typeRow.removeClass('d-none')
            $yearCell.addClass('d-none')
            $subjectDiv.addClass('d-none')
            $messageType.val('MESSAGE').trigger('change')
        } else {
            $uploadModalLabel.html('<i class="fa fa-cloud-upload me-2"></i>Neue Nachricht oder Datei hochladen')
            $('#messageTypeLabel').text('Nachrichtentyp')
            $typeRow.removeClass('d-none')
            $yearCell.removeClass('d-none')
            $subjectDiv.removeClass('d-none')
            $messageType.trigger('change')
        }
    })

    let uploadAccumulatedFiles = []

    if (!isSecureUserArea()) {
        return
    }

    tinymce.init({
        selector: '#messageBody',
        license_key: 'gpl',
        skin: 'oxide',
        content_css: 'default',
        menubar: false,
        plugins: 'link code lists',
        toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
        branding: false,
        height: 150
    });

    const $messageType = $('#messageType')
    if ($messageType.length) {
        const $messageYear = $('#messageYear')
        const $messageSubjectDiv = $('#messageSubjectDiv')
        const $messageBodyDiv = $('#messageBodyDiv')
        const $messageFileDiv = $('#messageFileDiv')
        const $messageFileSection = $('#messageFileSection')
        const $messageDocumentType = $('#messageDocumentType')
        const $messageSubject = $('#messageSubject')
        const $messageBody = $('#messageBody')
        const $messageFile = $('#messageFile')
        const $uploadFileError = $('#uploadFileError')
        const $uploadMessageForm = $('#uploadMessageForm')

        const toggleField = ($element, shouldShow) => {
            if (!$element.length) return
            $element.toggleClass('d-none', !shouldShow)
        }

        const updateFieldRequirements = (element, isRequired) => {
            if (!element.length) return
            element.prop('required', isRequired)
        }

        const resetFieldValue = (element) => {
            if (!element.length) return
            if (element.is('select')) {
                element.prop('selectedIndex', 0)
            } else if (element.is(':file')) {
                element.val('')
            } else {
                element.val('')
            }
        }

        const clearError = () => {
            if ($uploadFileError.length) {
                $uploadFileError.addClass('d-none').empty()
            }
        }

        let messageBodyRequired = false

        const ensureTextareaNotRequired = () => {
            if (!$messageBody.length) return
            $messageBody.prop('required', false)
            $messageBody.removeAttr('required')
            const editorInstance = typeof tinymce !== 'undefined' ? tinymce.get($messageBody.attr('id')) : null
            if (editorInstance && editorInstance.getElement()) {
                editorInstance.getElement().required = false
                editorInstance.getElement().removeAttribute('required')
            }
        }

        const handleMessageTypeChange = () => {
            const selectedType = $messageType.val()

            if (selectedType === 'MESSAGE') {
                uploadAccumulatedFiles = []
                toggleField($messageFileDiv, false)
                toggleField($messageFileSection, false)
                toggleField($messageSubjectDiv, true)
                toggleField($messageBodyDiv, true)

                updateFieldRequirements($messageFile, false)
                updateFieldRequirements($messageSubject, true)

                messageBodyRequired = true
            } else if (selectedType === 'FILE_UPLOAD') {
                toggleField($messageFileDiv, true)
                toggleField($messageFileSection, true)
                toggleField($messageSubjectDiv, true)
                toggleField($messageBodyDiv, true)

                updateFieldRequirements($messageFile, false)
                updateFieldRequirements($messageSubject, true)

                messageBodyRequired = false
            } else {
                toggleField($messageFileDiv, false)
                toggleField($messageFileSection, false)
                toggleField($messageSubjectDiv, true)
                toggleField($messageBodyDiv, true)

                updateFieldRequirements($messageFile, false)
                updateFieldRequirements($messageSubject, true)

                messageBodyRequired = false
            }

            ensureTextareaNotRequired()
            clearError()
        }

        ensureTextareaNotRequired()
        handleMessageTypeChange()

        $messageType.on('change', handleMessageTypeChange)

        const $titlesContainer = $('#messageFileTitlesContainer')
        const $titlesList = $('#messageFileTitlesList')
        const $docTypeTemplate = $('#messageDocumentType')

        // Akkumulierte Dateien für Mehrfach-Upload (neue Auswahl wird hinzugefügt, nicht ersetzt)
        const MAX_FILES = 5
        const MAX_FILE_SIZE = 5 * 1024 * 1024

        const renderFileList = (opts) => {
            const removedAtIndex = (opts && opts.removedAtIndex) >= 0 ? opts.removedAtIndex : -1
            const savedTitles = (opts && opts.savedTitles) || {}
            const savedDocTypes = (opts && opts.savedDocTypes) || {}

            if (removedAtIndex < 0) {
                $('.message-file-title').each(function () {
                    const i = parseInt($(this).data('file-index'), 10)
                    if (!isNaN(i)) savedTitles[i] = $(this).val()
                })
                $('.message-file-doctype').each(function () {
                    const i = parseInt($(this).data('file-index'), 10)
                    if (!isNaN(i)) savedDocTypes[i] = $(this).val()
                })
            }

            $titlesList.empty()
            if (uploadAccumulatedFiles.length > 0) {
                $titlesContainer.removeClass('d-none')
                $docTypeTemplate.prop('required', false).removeAttr('required')
                const defaultDocType = $docTypeTemplate.val() || ''
                uploadAccumulatedFiles.forEach(function (file, idx) {
                    const oldIdx = removedAtIndex >= 0 ? (idx < removedAtIndex ? idx : idx + 1) : idx
                    const prevTitle = savedTitles[oldIdx] || ''
                    const prevDoctype = savedDocTypes[oldIdx] || defaultDocType

                    const label = file.name || 'Datei ' + (idx + 1)
                    const $wrap = $('<div class="mb-3 p-3 border rounded message-file-card position-relative"></div>')
                    $wrap.attr('data-file-index', idx)
                    const $removeBtn = $('<button type="button" class="btn btn-sm btn-outline-danger position-absolute top-0 end-0 m-2 message-file-remove" title="Datei entfernen" data-file-index="' + idx + '"><i class="fa fa-times"></i></button>')
                    $wrap.append($removeBtn)
                    $wrap.append($('<label class="form-label small mb-1 fw-bold pe-4"></label>').text(label))
                    const $titleRow = $('<div class="mb-2"></div>')
                    $titleRow.append($('<label class="form-label small mb-0">Titel (optional)</label>'))
                    const $titleInput = $('<input type="text" class="form-control form-control-sm message-file-title" data-file-index="' + idx + '" placeholder="z.B. Nachweis Kindergeld Max" maxlength="80">')
                    $titleInput.val(prevTitle)
                    $titleRow.append($titleInput)
                    $wrap.append($titleRow)
                    const $doctypeRow = $('<div></div>')
                    $doctypeRow.append($('<label class="form-label small mb-0">Dokumententyp <span class="text-danger">*</span></label>'))
                    const $select = $('<select class="form-select form-select-sm message-file-doctype" data-file-index="' + idx + '" required></select>')
                    $docTypeTemplate.find('option').clone().appendTo($select)
                    $select.val(prevDoctype || defaultDocType)
                    $doctypeRow.append($select)
                    $wrap.append($doctypeRow)
                    $titlesList.append($wrap)
                })
                if (uploadAccumulatedFiles.length < MAX_FILES) {
                    const $addMore = $('<div class="mt-2"><button type="button" class="btn btn-sm btn-outline-secondary message-file-add-more"><i class="fa fa-plus me-1"></i> Weitere Datei hinzufügen</button></div>')
                    $titlesList.append($addMore)
                }
            } else {
                $titlesContainer.addClass('d-none')
            }
        }

        const clearAccumulatedFiles = () => {
            uploadAccumulatedFiles = []
            $messageFile.val('')
            $titlesList.empty()
            $titlesContainer.addClass('d-none')
        }

        $(document).on('uploadForm:reset', clearAccumulatedFiles)

        $messageFile.on('change', function () {
            const newFiles = this.files ? Array.from(this.files) : []
            this.value = ''
            if (newFiles.length === 0) return
            const remaining = MAX_FILES - uploadAccumulatedFiles.length
            if (remaining <= 0) return
            const toAdd = newFiles.slice(0, remaining)
            for (let i = 0; i < toAdd.length; i++) {
                const f = toAdd[i]
                if (f.size > MAX_FILE_SIZE) continue
                uploadAccumulatedFiles.push(f)
            }
            renderFileList()
        })

        $(document).on('click', '.message-file-add-more', function () {
            $messageFile.trigger('click')
        })

        $(document).on('click', '.message-file-remove', function (e) {
            e.preventDefault()
            const idx = parseInt($(this).data('file-index'), 10)
            const savedTitles = {}
            const savedDocTypes = {}
            $('.message-file-title').each(function () {
                const i = parseInt($(this).data('file-index'), 10)
                if (!isNaN(i)) savedTitles[i] = $(this).val()
            })
            $('.message-file-doctype').each(function () {
                const i = parseInt($(this).data('file-index'), 10)
                if (!isNaN(i)) savedDocTypes[i] = $(this).val()
            })
            uploadAccumulatedFiles.splice(idx, 1)
            renderFileList({ savedTitles, savedDocTypes, removedAtIndex: idx })
        })
    }


    const handleUploadFormSubmit = function (event) {

        event.preventDefault()
        event.stopPropagation()
        
        const $uploadMessageForm = $(event.target)
        const formElement = $uploadMessageForm[0]
        
        const $messageBody = $('#messageBody')
        if ($messageBody.length) {
            $messageBody.prop('required', false)
            $messageBody.removeAttr('required')
            const editorInstance = typeof tinymce !== 'undefined' ? tinymce.get($messageBody.attr('id')) : null
            if (editorInstance && editorInstance.getElement()) {
                editorInstance.getElement().required = false
                editorInstance.getElement().removeAttribute('required')
            }
        }
        
        // Let native HTML5 validation run first
        if (formElement && !formElement.checkValidity()) {
            // Native validation failed - let browser show its error messages
            formElement.reportValidity()
            return false
        }
        
        // Get form elements
        const $messageType = $('#messageType')
        const $messageYear = $('#messageYear')
        const $messageSubject = $('#messageSubject')
        const $messageFile = $('#messageFile')
        const $messageDocumentType = $('#messageDocumentType')
        const $uploadFileError = $('#uploadFileError')
        
        // Clear custom errors
        if ($uploadFileError.length) {
            $uploadFileError.addClass('d-none').empty()
        }

        const selectedType = $messageType.length ? $messageType.val() : ''
        const subjectValue = ($messageSubject.length ? $messageSubject.val() : '').trim()
        const editorInstance = typeof tinymce !== 'undefined' && $messageBody.length ? tinymce.get($messageBody.attr('id')) : null
        const editorContent = editorInstance ? editorInstance.getContent() : ($messageBody.length ? $messageBody.val() : '')
        const plainTextContent = editorInstance ? editorInstance.getContent({ format: 'text' }).trim() : ($messageBody.length ? ($messageBody.val() || '').trim() : '')

        if (editorInstance) {
            $messageBody.val(editorContent)
        }

        // Additional custom validation beyond HTML5
        const errors = []

        // Check if message body is required (only if messageType exists and is MESSAGE)
        const messageBodyRequired = $messageType.length && selectedType === 'MESSAGE'
        if (messageBodyRequired && !plainTextContent) {
            errors.push('Bitte geben Sie eine Nachricht ein.')
        }

        if (selectedType === 'FILE_UPLOAD') {
            const files = (typeof uploadAccumulatedFiles !== 'undefined' && uploadAccumulatedFiles.length > 0)
                ? uploadAccumulatedFiles
                : ($messageFile.length && $messageFile[0].files ? Array.from($messageFile[0].files) : [])
            if (!files || files.length === 0) {
                errors.push('Bitte wählen Sie mindestens eine Datei aus.')
            } else if (files.length > 5) {
                errors.push('Maximal 5 Dateien erlaubt.')
            } else {
                const maxSize = 5 * 1024 * 1024 // 5MB
                const tooLarge = files.filter(f => f.size > maxSize)
                if (tooLarge.length > 0) {
                    errors.push('Jede Datei darf maximal 5MB groß sein. ' + tooLarge.length + ' Datei(en) überschreiten dieses Limit.')
                }
                const missingDoctype = $('.message-file-doctype').filter(function () { return !$(this).val() || $(this).val() === '' })
                if (missingDoctype.length > 0) {
                    errors.push('Bitte wählen Sie für jede Datei einen Dokumententyp.')
                }
            }
        }

        if (errors.length) {
            if ($uploadFileError.length) {
                $uploadFileError
                    .removeClass('d-none')
                    .html(errors.join('<br>'))
            } else {
                makeAlertBoxModal(ALERT_TYPES.DANGER, 4000, errors.join('<br>'))
            }
            return false
        }

        // All validations passed - trigger validated event
        // Extrahiere Datei-Titel und Dokumententyp für jede Datei (aus akkumulierten Dateien)
        const files = (typeof uploadAccumulatedFiles !== 'undefined' && uploadAccumulatedFiles.length > 0)
            ? uploadAccumulatedFiles
            : ($messageFile.length && $messageFile[0].files ? Array.from($messageFile[0].files) : [])
        const fileTitles = []
        const fileDocumentTypes = []
        $('.message-file-title').each(function () {
            const v = ($(this).val() || '').trim()
            fileTitles.push(v || undefined)
        })
        $('.message-file-doctype').each(function () {
            fileDocumentTypes.push($(this).val() || '')
        })
        const payload = {
            type: selectedType,
            year: $messageYear.length ? $messageYear.val() : undefined,
            subject: subjectValue,
            documentType: $messageDocumentType.length ? $messageDocumentType.val() : undefined,
            messageHtml: editorContent,
            messageText: plainTextContent,
            files: files.length > 0 ? files : undefined,
            fileTitles: fileTitles.length > 0 ? fileTitles : undefined,
            fileDocumentTypes: fileDocumentTypes.length > 0 ? fileDocumentTypes : undefined,
            parentMessageId: $('#parentMessageId').length ? ($('#parentMessageId').val() || '').trim() || undefined : undefined,
            form: $uploadMessageForm
        }

        $(document).trigger('uploadMessage:validated', payload)

        return false
    }

    // Use event delegation on document to catch form submits even if form is loaded dynamically
    $(document).on('submit', '#uploadMessageForm', handleUploadFormSubmit)
    

})

function getAktMessages (year, type, count, countstart, jwtToken, isArchivedMemberPortal, enableArchiveActions) {
    // Da wir lokal filtern, fordern wir standardmäßig eine hohe Anzahl an Nachrichten an
    const messageCount = count || 100;
    const messageStart = countstart || 0;
    const data = {
        messageyear: year,
        messagetype: type,
        messagecount: messageCount,
        messagecountstart: messageStart,
        jwtToken: jwtToken
    }
    // API 0.9.2: optional GET-Filter isArchivedMemberPortal (nur wenn gesetzt)
    if (typeof isArchivedMemberPortal === 'boolean') {
        data.isArchivedMemberPortal = isArchivedMemberPortal
    }
    if (enableArchiveActions === true || enableArchiveActions === 'true') {
        data.enableArchiveActions = true
    }

    // JSON statt form-urlencoded: Booleans (enableArchiveActions, isArchivedMemberPortal) zuverlässig für Koa
    return $.ajax({
        method: 'POST',
        url: '/cockpit/actmessages',
        contentType: 'application/json; charset=UTF-8',
        data: JSON.stringify(data),
        processData: false,
        global: false, // Prevent global error handler
    }).then(function (result) {
        // Prüfe auf neue Response-Struktur mit success/error
        if (result && typeof result === 'object') {
            if (result.success === false) {
                return Promise.reject(new Error(result.error || 'Aktuelle Nachrichten können nicht abgerufen werden'))
            }
            // Wenn success: true, dann ist das HTML in result.data oder direkt in result
            if (result.success === true && result.data !== undefined) {
                return result.data
            }
        }
        // Alte Struktur: direkt HTML oder Error-Objekt
        if (result.error !== undefined) {
            return Promise.reject(new Error(result.error || 'Aktuelle Nachrichten können nicht abgerufen werden'))
        }
        // Direktes HTML (von ctx.render)
        return result
    }).catch(function (err) {
        // Pass through auth errors (401/403) with status intact - handleAuthError will handle them
        if (err.status === 401 || err.status === 403) {
            return Promise.reject(err) // Keep original error with status
        }
        // Handle other errors
        if (err.responseJSON && err.responseJSON.error) {
            return Promise.reject(new Error(err.responseJSON.error))
        }
        return Promise.reject(err)
    })
}

function getMessageDetail (messageid) {
    return $.ajax({
        method: 'POST',
        url: '/cockpit/actmessagesdetail',
        global: false, // Prevent global error handler
        data: {
          messageid: messageid
          // No jwtToken parameter needed - uses Authorization header
        }
    }).then(function (result) {
        // Prüfe auf neue Response-Struktur mit success/error
        if (result && typeof result === 'object') {
            if (result.success === false) {
                return Promise.reject(new Error(result.error || 'Nachrichtendetails können nicht abgerufen werden'))
            }
            // Wenn success: true, dann ist das HTML in result.data oder direkt in result
            if (result.success === true && result.data !== undefined) {
                return result.data
            }
        }
        // Alte Struktur: direkt HTML (von ctx.render) oder Error-Objekt
        if (result.error !== undefined) {
            return Promise.reject(new Error(result.error || 'Nachrichtendetails können nicht abgerufen werden'))
        }
        // Direktes HTML (von ctx.render)
        return result
    }).catch(function (err) {
        // Pass through auth errors (401/403) with status intact
        if (err.status === 401 || err.status === 403) {
            return Promise.reject(err) // Keep original error with status
        }
        if (err.responseJSON && err.responseJSON.error) {
            return Promise.reject(new Error(err.responseJSON.error))
        }
        return Promise.reject(err)
    }).then(function (result) {
        if (result.error !== undefined) {
            return Promise.reject(new Error('Nachricht '+ messageid +' kann nicht abgerufen werden'))
        }
        return result
    }).catch(function (err) {
        // Handle auth errors (401/403)
        if (handleAuthError(err, false)) {
            return Promise.reject(new Error('Sitzung abgelaufen'))
        }
        if (err.status === 403) {
            return Promise.reject(new Error('Daten können nicht abgerufen werden'))
        }
        return Promise.reject(new Error(err))
    })
}

/**
 * Archiv-Status einer Nachricht setzen (API 0.9.2, PATCH authorized/me/messages/…/archive).
 * @param {string} messageId - UUID der Nachricht (Root-ID bei zusammengefassten Karten)
 * @param {boolean} isArchivedMemberPortal - true = archivieren, false = wiederherstellen
 */
function patchMessageArchive (messageId, isArchivedMemberPortal) {
    return $.ajax({
        method: 'PATCH',
        url: '/cockpit/messages/' + encodeURIComponent(messageId) + '/archive',
        contentType: 'application/json; charset=UTF-8',
        data: JSON.stringify({
            data: {
                type: 'messages',
                attributes: { isArchivedMemberPortal: isArchivedMemberPortal }
            }
        }),
        global: false
    }).then(function (result) {
        if (result && result.success === false) {
            return Promise.reject(new Error(result.error || 'Archiv konnte nicht aktualisiert werden'))
        }
        return result
    }).catch(function (err) {
        if (err.status === 401 || err.status === 403) {
            return Promise.reject(err)
        }
        if (err.responseJSON && err.responseJSON.error) {
            return Promise.reject(new Error(err.responseJSON.error))
        }
        return Promise.reject(err)
    })
}

/// //////////////////
// Authentication //
/// //////////////////

/**
 * Speichert Portal-Session nach erfolgreichem Login.
 */
function storePortalSession (result) {
    const userData = {
        thumb: result.thumb,
        user: result.user,
        accountType: result.accountType || 'MEMBER',
        accountName: result.accountName || ''
    }
    localStorage.setItem('token', result.token)
    localStorage.setItem('user', JSON.stringify(userData))
    localStorage.removeItem('api')
    localStorage.removeItem('jwt')
    localStorage.removeItem('jwtToken')
}

/**
 * Logs in a user with username and password
 * @returns {Promise} - Promise that resolves when login is successful or MFA is required
 */
function login() {

    const username = $('#username').val()
    const password = $('#password').val()

    return $.ajax({
        method: 'POST',
        url: '/auth/login',
        data: {
            type: 'user',
            username: username,
            password: password
        }
    }).then(function (result) {
        if (result.error !== undefined) {
            return Promise.reject(result.error && result.error.message ? result.error.message : JSON.stringify(result.error))
        }

        if (result.mfaRequired && result.mfaChallengeToken) {
            return {
                mfaRequired: true,
                mfaChallengeToken: result.mfaChallengeToken,
                username: username
            }
        }

        if (!result.token) {
            return Promise.reject(result.error && result.error.message ? result.error.message : JSON.stringify(result.error))
        }

        storePortalSession(result)
        return result
    }).catch(function (err) {
        return Promise.reject(err)
    })
}

/**
 * MFA-Schritt nach Login (API 0.10.2)
 * @param {string} username
 * @param {string} mfaChallengeToken
 * @param {string} pin
 */
function loginMfa (username, mfaChallengeToken, pin) {
    return $.ajax({
        method: 'POST',
        url: '/auth/login-mfa',
        data: {
            username: username,
            mfaChallengeToken: mfaChallengeToken,
            pin: pin
        }
    }).then(function (result) {
        if (result.error !== undefined) {
            return Promise.reject(result.error && result.error.message ? result.error.message : JSON.stringify(result.error))
        }
        if (!result.token) {
            return Promise.reject(result.error || 'Anmeldung fehlgeschlagen')
        }
        storePortalSession(result)
        return result
    }).catch(function (err) {
        return Promise.reject(err)
    })
}

/// //////////////////
// Utility Functions //
/// //////////////////

/**
 * Shows loading spinner
 */
function showLoading() {
    $('.spinner').show()
}

/**
 * Hides loading spinner
 */
function hideLoading() {
    $('.spinner').hide()
}


/// ///////////////////
// Popup Management //
/// ///////////////////

/**
 * Initializes Bootstrap Popovers and Tooltips globally
 */
function initPopups() {
    // Initialize Popovers
    const popoverElements = document.querySelectorAll('[data-bs-toggle="popover"]')
    Array.from(popoverElements).forEach(element => {
        new bootstrap.Popover(element, {
            trigger: 'focus'
        })
    })
    
    // Initialize Tooltips
    const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    Array.from(tooltipElements).forEach(element => {
        new bootstrap.Tooltip(element)
    })
}

/// ////////////////////
// Navigation/Sidebar //
/// ////////////////////

/**
 * Toggles the mobile sidebar between open and closed state
 * @param {Event} e - Click event
 */
function toggleNav(e) {
    const sidebar = document.getElementById('mobilesidebar')
    if (!sidebar) return
    
    if (sidebar.style.width === '100%') {
        closeNav(e)
    } else {
        openNav(e)
    }
}

/**
 * Opens the mobile sidebar
 * @param {Event} x - Click event
 */
function openNav(x) {
    const sidebar = document.getElementById('mobilesidebar')
    const toggle = document.getElementById('mobiletoggle')
    
    if (sidebar) sidebar.style.width = '100%'
    if (toggle) toggle.classList.toggle('change')
}

/**
 * Closes the mobile sidebar
 * @param {Event} x - Click event
 */
function closeNav(x) {
    const sidebar = document.getElementById('mobilesidebar')
    const toggle = document.getElementById('mobiletoggle')
    
    if (sidebar) sidebar.style.width = '0'
    if (toggle) toggle.classList.toggle('change')
}

/// ////////////////////////////
// Alert Box Functions //
/// ////////////////////////////

/**
 * Alert type constants for better maintainability
 */
const ALERT_TYPES = {
    SUCCESS: 0,
    INFO: 1,
    WARNING: 2,
    DANGER: 3
}

/**
 * Maps alert type to CSS selector
 * @param {number} id - Alert type ID
 * @returns {string} - CSS selector
 */
function getAlertSelector(id) {
    const selectors = {
        0: '#info-success',
        1: '#info-info',
        2: '#info-warning',
        3: '#info-danger'
    }
    return selectors[id] || selectors[0]
}

/**
 * Maps alert type to modal CSS selector
 * @param {number} id - Alert type ID
 * @returns {string} - CSS selector
 */
function getAlertSelectorModal(id) {
    const selectors = {
        0: '#info-success-modal',
        1: '#info-info-modal',
        2: '#info-warning-modal',
        3: '#info-danger-modal'
    }
    return selectors[id] || selectors[0]
}

/**
 * Displays an alert box with the specified message
 * @param {number} type - Alert type (0=success, 1=info, 2=warning, 3=danger)
 * @param {number} delay - Display duration in milliseconds
 * @param {string} message - Message to display
 * @param {string|null} inlineSelector - Optional CSS selector for inline alert (e.g., '#myInlineAlert')
 */
function makeAlertBox(type, delay, message, inlineSelector) {
    // If inline selector provided, use inline alert
    if (inlineSelector && $(inlineSelector).length > 0) {
        const alertClasses = ['alert-success', 'alert-info', 'alert-warning', 'alert-danger']
        const $alert = $(inlineSelector)
        
        $alert
            .removeClass('hidden ' + alertClasses.join(' '))
            .addClass(alertClasses[type] || alertClasses[0])
            .html(message)
            .show()
        
        if (delay) {
            setTimeout(function() {
                $alert.addClass('hidden').hide()
            }, delay)
        }
    } else {
        // Use fixed alert (default behavior)
        const selector = getAlertSelector(type)
        $(selector)
            .removeClass('hidden')
            .html(message)
            .delay(delay)
            .queue(function (next) {
                $(this).addClass('hidden')
                next()
            })
    }
}

/**
 * Displays an alert box in a modal with the specified message
 * @param {number} type - Alert type (0=success, 1=info, 2=warning, 3=danger)
 * @param {number} delay - Display duration in milliseconds
 * @param {string} message - Message to display
 */
function makeAlertBoxModal(type, delay, message) {
    const selector = getAlertSelectorModal(type)
    $(selector)
        .removeClass('hidden')
        .html(message)
        .delay(delay)
        .queue(function (next) {
            $(this).addClass('hidden')
            next()
        })
}

/// ///////////////////
// Cookie Functions //
/// ///////////////////

/**
 * Sets a cookie with the specified name, value, and expiration
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} expire - Expiration time in hours
 */
function setCookie(name, value, expire) {
    const date = new Date()
    date.setTime(date.getTime() + (expire * 60 * 60 * 1000))
    const expires = `expires=${date.toUTCString()}`
    document.cookie = `${name}=${value};path=/;${expires}`
}

/**
 * Gets the value of a cookie by name
 * @param {string} name - Cookie name to retrieve
 * @returns {string} - Cookie value or empty string if not found
 */
function getCookie(name) {
    const nameEQ = `${name}=`
    const cookies = document.cookie.split(';')
    
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i]
        // Remove leading whitespace
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1)
        }
        // Check if this is the cookie we're looking for
        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length)
        }
    }
    return ''
}
